import { useEffect, useState } from "react";
import CommonModal from "../modalLayout/CommonModal";

/**
 * Edit VA clinician "Provider name" — Confirm saves immediately.
 */
export default function EditProviderNameModal({
  show,
  setShow,
  initialValue = "",
  onSave,
  confirmLoading = false,
}) {
  const [draft, setDraft] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!show) return;
    setDraft(String(initialValue || "").trim());
    setError(false);
  }, [show, initialValue]);

  const handleConfirm = async () => {
    if (confirmLoading) return;
    const value = draft.trim();
    if (!value) {
      setError(true);
      return;
    }
    try {
      await onSave?.(value);
      setShow?.(false);
    } catch {
      // Parent shows toast; keep modal open for retry.
    }
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title="Edit Provider name"
      centered
      onConfirm={handleConfirm}
      confirmLabel="Confirm"
      confirmLoading={confirmLoading}
      confirmDisabled={!draft.trim() || confirmLoading}
      cancelDisabled={confirmLoading}
    >
      <input
        type="text"
        value={draft}
        onChange={(e) => {
          setDraft(e.target.value);
          if (error) setError(false);
        }}
        className={`form-control${error ? " is-invalid" : ""}`}
        placeholder="Provider name"
        autoFocus
        disabled={confirmLoading}
        aria-invalid={error}
      />
      {error ? (
        <p className="text-danger small mb-0 mt-2">Provider name is required</p>
      ) : null}
    </CommonModal>
  );
}
